import React from 'react';

import { OrderedList, UnorderedList } from './StyledComponents';

interface ListProps {
  children: React.ReactNode | React.ReactNode[];
  type: 'ordered' | 'unordered';
  margin?: string;
}

export const List = ({
  children,
  type,
  margin,
}: ListProps): React.ReactElement => {
  switch (type) {
    case 'ordered':
      return (
        <OrderedList
          aria-label="Ordered-list"
          id="ordered-list"
          margin={margin}
        >
          {children}
        </OrderedList>
      );
      break;
    default:
      return (
        <UnorderedList
          aria-label="Unordered-list"
          id="unordered-list"
          margin={margin}
        >
          {children}
        </UnorderedList>
      );
  }
};
